import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './DevBlogPreview.css';

const BLOG_URL = 'https://blog.koiro.me';
const POSTS_JSON_URL = 'https://blog.koiro.me/posts.json';

function formatPostDate(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return `${months[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
}

function DevBlogPreview() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const fetchPosts = async () => {
      try {
        const res = await fetch(POSTS_JSON_URL);
        if (!res.ok || cancelled) return;
        const data = await res.json();
        if (!cancelled && Array.isArray(data)) setPosts(data);
      } catch {
        if (!cancelled) setPosts([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    fetchPosts();
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="devblog-preview">
      <Link to="/dev-blog" className="devblog-preview-card" aria-label="KOIRO Dev Blog 미리보기">
        <div className="devblog-preview-card-top">
          <span className="devblog-preview-kicker">DEV BLOG</span>
          <span className="devblog-preview-cta">미리보기 →</span>
        </div>
        <span className="devblog-preview-domain">blog.koiro.me</span>
        <p className="devblog-preview-sub">개인 로드맵 기반 개발 기록 · 학습 & 실험</p>
      </Link>

      {!loading && posts.length > 0 && (
        <div className="devblog-preview-list">
          <p className="devblog-preview-list-title">최근 글</p>
          <ul>
            {posts.map((post, i) => (
              <li key={post.url || i} data-stagger>
                <a
                  href={post.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="devblog-preview-row"
                >
                  <span className="devblog-preview-num">{String(i + 1).padStart(2, '0')}</span>
                  <span className="devblog-preview-link">{post.title}</span>
                  <span className="devblog-preview-right">
                    {post.date && (
                      <span className="devblog-preview-date">{formatPostDate(post.date)}</span>
                    )}
                    <span className="devblog-preview-arrow">→</span>
                  </span>
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
      {!loading && posts.length === 0 && (
        <p className="devblog-preview-hint">blog.koiro.me에서 로드맵과 개발 기록을 볼 수 있습니다.</p>
      )}
    </div>
  );
}

export default DevBlogPreview;
